import { createContext, useContext, ReactNode } from 'react';
import { useVisitorTracking } from '@/hooks/use-visitor-tracking';

// Context type
interface TrackingContextType {
    visitorId: string;
    sessionId: string;
    hasConsent: boolean;
    setConsent: (consent: boolean) => void;
    trackClick: (elementId: string, elementText?: string, metadata?: Record<string, unknown>) => void;
    trackSectionView: (sectionId: string, sectionTitle?: string, durationMs?: number) => void;
    trackScroll: (scrollPercent: number) => void;
    isNewsletterDismissed: () => boolean;
    dismissNewsletter: (permanent: boolean) => void;
    captureContact: (email?: string, phone?: string, name?: string) => Promise<void>;
}

const TrackingContext = createContext<TrackingContextType | null>(null);

interface TrackingProviderProps {
    children: ReactNode;
}

export function TrackingProvider({ children }: TrackingProviderProps) {
    const tracking = useVisitorTracking();

    return (
        <TrackingContext.Provider value={tracking}>
            {children}
        </TrackingContext.Provider>
    );
}

export function useTracking() {
    const context = useContext(TrackingContext);
    if (!context) {
        throw new Error('useTracking must be used within a TrackingProvider');
    }
    return context;
}
